import { useEffect } from 'react'

export default function ErrorPlaceholder({ error }) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <span>{`Application error: a server-side exception has occurred`}</span>
  )
}
